export { CurrencyRatePageTemplate } from "./CurrencyRatePageTemplate";
export { CurrencyRatePageTemplateOld } from "./CurrencyRatePageTemplateOld";
